module.exports = __webpack_public_path__ + "static/img/top5-rxqg.410eab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top5-rxqg.png
// module id = 0rL/
// module chunks = 12